import React from 'react';
import './CanvasWorkspaceSidebar.css';

const noop = () => {};

function CanvasWorkspaceSidebar({
  activeKey,
  onInspiration = noop,
  onGenerate = noop,
  onAssets = noop,
  onCanvas = noop
}) {
  const navItems = [
    {
      key: 'inspiration',
      label: '灵感',
      onClick: onInspiration,
      icon: (
        <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
          <path d="M12 2.7 2.5 10.7h2.5v10h5v-6h4v6h5v-10h2.5L12 2.7z" />
        </svg>
      )
    },
    {
      key: 'generate',
      label: '生成',
      onClick: onGenerate,
      icon: (
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M12 3v18M3 12h18" />
        </svg>
      )
    },
    {
      key: 'assets',
      label: '资产',
      onClick: onAssets,
      icon: (
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="3" y="7" width="18" height="13" rx="2" />
          <path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
          <path d="M3 13h18" />
        </svg>
      )
    },
    {
      key: 'canvas',
      label: '画布',
      onClick: onCanvas,
      icon: (
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="5" cy="6" r="2" fill="currentColor" stroke="none" />
          <circle cx="19" cy="18" r="2" fill="currentColor" stroke="none" />
          <circle cx="5" cy="18" r="2" fill="currentColor" stroke="none" />
          <path d="M7 6h6.5M7 18h6.5M5 8.5v7M16.5 18l-2-9.5" />
        </svg>
      )
    }
  ];

  return (
    <aside className="CanvasWorkspaceSidebar">
      <nav className="CanvasWorkspaceSidebar-nav" aria-label="主导航">
        {navItems.map((item) => (
          <button
            key={item.key}
            type="button"
            className={`CanvasWorkspaceSidebar-item${activeKey === item.key ? ' is-active' : ''}`}
            aria-current={activeKey === item.key ? 'page' : undefined}
            onClick={item.onClick}
          >
            <span className="CanvasWorkspaceSidebar-item-icon" aria-hidden="true">{item.icon}</span>
            <span className="CanvasWorkspaceSidebar-item-label">{item.label}</span>
          </button>
        ))}
      </nav>
    </aside>
  );
}

export default CanvasWorkspaceSidebar;
